export class RatePackageEventType {

	static STEPS = {
		MY_PACKAGE: 'MY_PACKAGE',
		EXTRACT: 'EXTRACT',
		OTHERS: 'OTHERS',
		CONFIRM: 'CONFIRM',
		RESULT: 'RESULT'
	};

	static SEND = {
		DATA_CONFIRM: 'DATA_CONFIRM'
	};

	static MODAL = {
		TRUE_MODAL: 'TRUE_MODAL'
	};

	static HIRE_PACKAGE = 'HIRE_PACKAGE';
	static ERROR = 'PACKAGE_ERROR';
	static BUTTONS = 'PACKAGE_ERROR';
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rate-package/rate-package.event.type.ts